module.exports = __webpack_public_path__ + "img/mannul_home_editdelete.56e47e10.png";